import React from "react";
import FilterButton from "./FilterButton";
import SingleParamsFilter from "./SingleParamsFilter";

const ListingTopFilter = ({ inputHandler, applicationId, psid, FilterForm, searchHandler }) => {
  return (
    <div className="d-flex">
      <SingleParamsFilter
        applicationId={applicationId}
        psid={psid}
        inputHandler={inputHandler}
      />
      <FilterButton FilterForm={FilterForm} searchHandler={searchHandler}/>
    </div>
  );
};

export default ListingTopFilter;
